@use "ui/styles/colors";
@use "ui/styles/sizes";

.wrapper {
  list-style: none;
  margin: 0;
  padding: 0;
  color: var(--text-color);
  position: relative;
  display: flex;
  flex-direction: row;
  gap: sizes.$s4;
  margin-inline: sizes.$s3;

  & li {
    position: relative;
    display: flex;
    padding: sizes.$s3;
    border-radius: sizes.$s3;

    &:hover:not(.disabled) {
      cursor: pointer;
      background-color: var(--secondary-background-color);
    }

    &.disabled {
      color: var(--secondary-text-color);
    }
  }
}